import { render, staticRenderFns } from "./GGError.vue?vue&type=template&id=1b319a68&"
import script from "./GGError.vue?vue&type=script&lang=js&"
export * from "./GGError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b319a68')) {
      api.createRecord('1b319a68', component.options)
    } else {
      api.reload('1b319a68', component.options)
    }
    module.hot.accept("./GGError.vue?vue&type=template&id=1b319a68&", function () {
      api.rerender('1b319a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGError.vue"
export default component.exports